import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 根据特殊货物获取装箱信息
export function getContainerUsages(params) {
  return request({
    url: URL.seaExport.specialGoodsContainerUsages,
    method: 'get',
    params
  })
}

// 特殊货物关联装箱信息
export function relatedContainerUsages(data) {
  return request({
    url: URL.seaExport.spgRelatedContainerUsages,
    method: 'post',
    data
  })
}

// 移除特殊货物关联装箱信息
export function unRelatedContainerUsages(data) {
  return request({
    url: URL.seaExport.spgUnRelatedContainerUsages,
    method: 'post',
    data
  })
}

// 导入excel
export function importSpecialGoods(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.seaExport.importSpecialGoods,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    },
    method: 'post',
    data
  })
}

